var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"vuestic-sidebar",class:{ 'sidebar-hidden': _vm.hidden }},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},[_vm._t("menu")],2)]),_c('img',{staticClass:"inno-support mx-auto",attrs:{"src":require('@/assets/images/inno-support.png'),"alt":"INNO SUPPORT"}}),(
      _vm.currentUser &&
        _vm.currentUser.userType === 'user' &&
        _vm.currentUser.completeControlTicketing
    )?_c('router-link',{staticClass:"inno-support-btn btn btn-sm btn-primary w-100",attrs:{"to":{ name: 'inno-support' }}},[_vm._v(_vm._s(_vm.$t('sidebar.support'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }